export default __webpack_public_path__ + "static/media/Sort.af83f2f6.jpg";